const capitalizeSentence = (str) => {
	if (!str) return ''
	str = str.trim()
	return str.replace(/.+?([.?!]\s|$)/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
	})
}
export default capitalizeSentence
